var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-platform-announcements"},[(!_vm.isComponentReady)?_c('div',{staticClass:"page-platform-announcements__content"},[_c('br'),_vm._v(" "),_c('static-page-loader')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"page-platform-announcements__content",domProps:{"innerHTML":_vm._s(_vm.content)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40220df4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/page-platform-announcements/page-platform-announcements.vue
// module id = teEc
// module chunks = 0